import TelegramIcon from "./telegram.svg";
export default TelegramIcon;